import { useEffect } from 'react'

export const JSONLD = ({ projects }) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.id = 'projects-jsonld'
    const itemList = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: projects.map((p, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@type': 'CreativeWork',
          name: p.title,
          description: p.description,
          dateCreated: String(p.year),
          url: window.location.origin + window.location.pathname + `#${p.id}`,
          about: p.tags,
          keywords: [...p.tags, ...p.skills].join(', '),
        },
      })),
    }
    script.textContent = JSON.stringify(itemList)
    const prev = document.getElementById('projects-jsonld')
    if (prev) prev.remove()
    document.head.appendChild(script)
    return () => { script.remove() }
  }, [projects])
  return null
}

export default JSONLD

